"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockInsightsQuery = void 0;
function mockInsightsQuery(request, result) {
    const compiledQuery = request.query(request.variables);
    const blobData = {
        values: result,
    };
    return {
        request: {
            messageType: 'CirrusBlobRequest',
            locationAddress: {
                resourceType: 'LocationAddress',
                locationId: request.context.locationId,
            },
            list: [
                {
                    resourceType: 'BlobDTO',
                    blobType: 'tsdb',
                    blobData: JSON.stringify({
                        query: 'id ' + compiledQuery.id,
                        lid: request.context.locationId,
                        params: compiledQuery.params,
                    }),
                },
            ],
        },
        responses: [
            {
                messageType: 'CirrusBlobResponse',
                list: [
                    {
                        blobData: JSON.stringify(blobData),
                        resourceType: 'BlobDTO',
                    },
                ],
            },
        ],
    };
}
exports.mockInsightsQuery = mockInsightsQuery;
//# sourceMappingURL=mockInsightsQuery.js.map